import { render } from "./TranslateArrows.vue?vue&type=template&id=0d0ca21e"
import script from "./TranslateArrows.vue?vue&type=script&lang=js"
export * from "./TranslateArrows.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__